import React from "react";

const FacebookIcon = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.36213 3.82542V5.96839H11.9993L11.5817 8.8551H9.36213V15.506C8.91712 15.568 8.46182 15.6004 7.99966 15.6004C7.46619 15.6004 6.94232 15.5577 6.43216 15.4749V8.8551H4V5.96839H6.43216V3.34638C6.43216 1.71968 7.74389 0.400391 9.36282 0.400391V0.401771C9.36762 0.401771 9.37173 0.400391 9.37653 0.400391H12V2.89696H10.2858C9.77629 2.89696 9.36282 3.3126 9.36282 3.82474L9.36213 3.82542Z"
      fill="white"
    />
  </svg>
);

export default FacebookIcon;
